import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-21e61fa5")

_pushScopeId("data-v-21e61fa5")
const _hoisted_1 = {
  class: "relative",
  style: {"z-index":"9999"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BaseAlertComponent = _resolveComponent("BaseAlertComponent")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_BaseAlertComponent, {
      "use-alert-list-message-from-storage": true,
      "alert-type": "error"
    }),
    _createVNode(_component_BaseAlertComponent, {
      "use-alert-list-message-from-storage": true,
      "alert-type": "success"
    }),
    _createVNode(_component_BaseAlertComponent, {
      "use-alert-list-message-from-storage": true,
      "alert-type": "warnings"
    })
  ]))
})